<template>
  <div>
    <table
      class="table is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium is-marginless has-cells-vcentered"
      v-if="mandats && mandats.length">
      <thead>
        <tr class="is-size-6">
          <th></th>
          <th>
            Canal de vente
          </th>
          <th>Date de début</th>
          <th>Date de fin</th>
          <th></th>
          <th>Rémunération</th>
        </tr>
      </thead>
      <tbody class="is-size-6">
        <tr
          v-for="(m, i) in mandats"
          :key="i">
          <td>
            <avatar
              :use-picto-custom="'fas fa-city'"
              :is-avatar="false"
              :use-picto="'fas fa-city'"
              class="has-background-grey-light is-medium has-text-white">
            </avatar>
          </td>
          <td>{{ m.sales_channel.name }}</td>
          <td>{{ m.start_date | date }}</td>
          <td>{{ m.end_date | date }}</td>
          <td class="is-narrow">
            <span
              v-if="filteredAllotments(m).length"
              class="tag is-allotement is-uppercase">
              {{ filteredAllotments(m).length }} {{ 'Lot' | pluralize(filteredAllotments(m).length > 1) }} {{ 'Alloté' | pluralize(filteredAllotments(m).length > 1) }}
            </span>
          </td>
          <td
            class="is-paddingless is-marginless"
            style="width: 150px;">
            <div class="field has-addons is-border-left">
              <div class="control is-expanded has-incrementations">
                <span
                  class="input is-borderless is-medium is-padding-top-small has-text-centered is-fullwidth">
                  {{ m.remuneration }}
                </span>
              </div>
              <div class="control">
                <a class="button is-static is-borderless is-square is-medium">
                  <span class="icon"><i class="fas fa-percentage"></i></span>
                </a>
              </div>
              <div
                class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <button
                    class="button is-square is-medium is-radiusless is-borderless"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu">
                    <i class="fal fa-ellipsis-v"></i>
                  </button>
                </div>
                <div
                  class="dropdown-menu"
                  role="menu">
                  <div class="dropdown-content has-text-left">
                    <a
                      class="dropdown-item">
                      <span class="icon is-size-5"><i class="fas fa-eye"></i></span>
                      <span
                        class="is-margin-left-xsmall"
                        @click="redirectChannel(m.sales_channel.pk)">Voir le canal</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucun mandat à afficher
    </div>
    <pagination
      class="has-background-transparent"
      :loading="false"
      :current-page="currentCanalPage"
      :total-page="currentCanalTotalPage"
      @changePage="loadItems($event)" />
  </div>
</template>

<script>
import { Error } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'MandatLightList',
  mixins: [Error],
  props: {
    allotments: {
      type: Array
    },
    accesses: {
      type: Array,
      require: true
    },
    accessesCount: {
      type: Number
    },
    currentCanalPage: {
      type: Number
    },
    currentCanalTotalPage: {
      type: Number
    },
    program: Object,
    lots: Array,
    mandats: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      selectedAccess: null
    }
  },
  computed: {
    ...mapGetters(['isPromoteur'])
  },
  methods: {
    loadItems (page) {
      this.$emit('loadAccessPage', page)
    },
    redirectChannel (id) {
      this.$router.push({ name: 'ChannelVue', params: { id } })
    },
    filteredAllotments (m) {
      return this.allotments.filter(x => m.pk.includes(x.mandat))
    }
  }
}
</script>
